import moment from 'moment';
import sharedApi from './SharedApi.js';
import userApi from './UserApi.js';

class GrantApi {

    path = "/api/grant";

    getPhaseCommentsPath = (grantId, phaseId) => {
        return `${this.path}/data/${grantId}/phases/${phaseId}/comments`;
    }

    getStepCommentsPath = (grantId, stepId) => {
        return `${this.path}/data/${grantId}/steps/${stepId}/comments`;
    }

    async getGrantData(id, onError) {
        return sharedApi.get('/api/grant/data/' + id, onError);
    }

    getGrantExternalUsersFiltered(grantId, role, skip, take, filter, onError) {
        return fetch(sharedApi.generateURL('api/grant/data/allexternalusers/') + grantId + '/' + role + '/' + skip + '/' + take + '/' + filter, {
            headers: {
                'Authorization': 'Bearer ' + userApi.getAccessToken(),
            }
        })
            .then((response) => response.json())
            .then((data) => ({
                data: data.data,
            }))
            .catch(() => {
                throw new Error('Data Loading Error');
            });
    }


    async getValidExternalUserInfo(emailAddress, onError) {
        return sharedApi.get('/api/grant/data/externaluserinfo/' + emailAddress, onError);
    }

    async getGrantExternalUsers(grantId, onError) {
        return sharedApi.get('/api/grant/data/externalusers/' + grantId, onError);
    }

    async deleteGrantExternalUser(grantId, userId, externalUserRole, onError) {
        return sharedApi.delete('/api/grant/data/deleteexternaluser/' + grantId + '/' + userId + '/' + externalUserRole, onError);
    }

    async addGrantExternalUser(grantId, emailAddress, firstName, lastName, role, onError) {
        const payload = { grantId: grantId, emailAddress: emailAddress, firstName: firstName, lastName: lastName, role: role };
        return sharedApi.post('/api/grant/data/addexternaluser', payload, false, onError);
    }

    async getPhaseData(id, onError) {
        return sharedApi.get('/api/grant/data/phases/' + id, onError);
    }

    async updateGrant(grantData, phaseData, onError) {
        const updateGrantModel = {
            Id: grantData.id,
            Override: grantData.override,
            BudgetEndDate: (grantData.budgetEndDate && grantData.budgetEndDate !== '') ? moment(grantData.budgetEndDate).format() : null,
            ShortTitle: grantData.shortTitle,
            ShortInstitution: grantData.shortInstitution
        }

        if (!!phaseData) {
            //console.log('phaseData');

            const schematicDesign = {
                Submission: (phaseData.schematicDesign.submission && phaseData.schematicDesign.submission !== '') ? moment(phaseData.schematicDesign.submission).format() : null,
                Completion: (phaseData.schematicDesign.completion && phaseData.schematicDesign.completion !== '') ? moment(phaseData.schematicDesign.completion).format() : null,
                Comments: phaseData.schematicDesign.comments
            };

            const designDevelopment = {
                Submission: (phaseData.designDevelopment.submission && phaseData.designDevelopment.submission !== '') ? moment(phaseData.designDevelopment.submission).format() : null,
                Completion: (phaseData.designDevelopment.completion && phaseData.designDevelopment.completion !== '') ? moment(phaseData.designDevelopment.completion).format() : null,
                Comments: phaseData.designDevelopment.comments
            }

            const constructionDocuments = {
                Submission: (phaseData.constructionDocuments.submission && phaseData.constructionDocuments.submission !== '') ? moment(phaseData.constructionDocuments.submission).format() : null,
                Completion: (phaseData.constructionDocuments.completion && phaseData.constructionDocuments.completion !== '') ? moment(phaseData.constructionDocuments.completion).format() : null,
                Comments: phaseData.constructionDocuments.comments
            }

            const recordDocuments = {
                Comments: phaseData.recordDocuments.comments
            }
            const designCompletion = {
                Submission: (phaseData.designCompletion.submission && phaseData.designCompletion.submission !== '') ? moment(phaseData.designCompletion.submission).format() : null,
                Comments: phaseData.designCompletion.comments
            }
            const bidding = {
                Submission: (phaseData.bidding.submission && phaseData.bidding.submission !== '') ? moment(phaseData.bidding.submission).format() : null,
                Completion: (phaseData.bidding.completion && phaseData.bidding.completion !== '') ? moment(phaseData.bidding.completion).format() : null,
                Comments: phaseData.bidding.comments
            }
            const construction = {
                Submission: (phaseData.construction.submission && phaseData.construction.submission !== '') ? moment(phaseData.construction.submission).format() : null,
                Completion: (phaseData.construction.completion && phaseData.construction.completion !== '') ? moment(phaseData.construction.completion).format() : null,
                Comments: phaseData.construction.comments,
            }

            Object.assign(updateGrantModel,
                {
                    SchematicDesign: schematicDesign,
                    DesignDevelopment: designDevelopment,
                    ConstructionDocuments: constructionDocuments,
                    RecordDocuments: recordDocuments,
                    DesignCompletion: designCompletion,
                    Bidding: bidding,
                    Construction: construction
                });
        }

        return await sharedApi.setJson('/api/grant/update', updateGrantModel, onError);
    }

    async getGrantReport(id, grantNumber, onError) {
        const url = sharedApi.generateURL('api/grant/report/' + id);
        //TODO add a loading indicator/overlay
        try {
            await fetch(url).then(function (response) {
                if (response?.ok)
                    return response.blob();

                //TODO display popup with error
            }).then(function (pdfBlob) {
                const fileURL = URL.createObjectURL(pdfBlob);
                window.open(fileURL, '_blank');
                setTimeout(() => {
                    URL.revokeObjectURL(fileURL);
                });
            });
        } catch (error) {
            console.error(error);
            //TODO display popup with error
        }
    }

    async assignSo(id, dto, onError) {
        try {
            var result = await sharedApi.post(this.path + "/" + id + "/users/so", dto, onError);
            return await result.json();
        } catch (error) {
            console.error(error);
            return error.message;
        }
    }
}

export default new GrantApi();
